'use client';

import { PropsWithClassname } from '@/app/types';
import { useTranslation } from 'react-i18next';

import Dialog from '@/app/components/Dialog/Dialog';

interface ProjectsVerificationDialogProps extends PropsWithClassname {
  isOpen: boolean;
  onClose: () => void;
}

const ProjectsVerificationDialog = ({ isOpen, onClose, className }: ProjectsVerificationDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      className={className}
      title={t('components.CollectionsVerificationDialog.title')}
      isCloseButtonVisible
    >
      <div className="max-h-full overflow-y-auto">
        <p className="my-[16px]">{t('components.CollectionsVerificationDialog.description')}</p>

        <div className="font-medium">
          {t('components.CollectionsVerificationDialog.firstVerificationPhase.heading')}
        </div>
        <ul className="list-disc mb-[16px]">
          {(
            t('components.CollectionsVerificationDialog.firstVerificationPhase.bulletPoints', {
              returnObjects: true,
            }) as Array<string>
          ).map?.((bulletPoint, index) => (
            <li className="ml-[32px]" key={index}>
              {bulletPoint}
            </li>
          ))}
        </ul>

        <div className="font-medium">
          {t('components.CollectionsVerificationDialog.secondVerificationPhase.heading')}
        </div>
        <ul className="list-disc mb-[16px]">
          {(
            t('components.CollectionsVerificationDialog.secondVerificationPhase.bulletPoints', {
              returnObjects: true,
            }) as Array<string>
          ).map?.((bulletPoint, index) => (
            <li className="ml-[32px]" key={index}>
              {bulletPoint}
            </li>
          ))}
        </ul>

        <div className="font-medium">
          {t('components.CollectionsVerificationDialog.thirdVerificationPhase.heading')}
        </div>
        <ul className="list-disc mb-[16px]">
          {(
            t('components.CollectionsVerificationDialog.thirdVerificationPhase.bulletPoints', {
              returnObjects: true,
            }) as Array<string>
          ).map?.((bulletPoint, index) => (
            <li className="ml-[32px]" key={index}>
              {bulletPoint}
            </li>
          ))}
        </ul>

        <div className="font-medium">{t('components.CollectionsVerificationDialog.problemsWithCollectionHeading')}</div>
        <p className="mb-[16px]">{t('components.CollectionsVerificationDialog.problemsWithCollectionText')}</p>

        <div className="font-medium">{t('components.CollectionsVerificationDialog.whatIsDonioHeading')}</div>
        <p className="mb-[16px]">{t('components.CollectionsVerificationDialog.whatIsDonioText')}</p>
      </div>
    </Dialog>
  );
};

export default ProjectsVerificationDialog;
